import { handleApiCall } from '@/apiClient'
import { JSON_HEADERS, basicAuthHeader } from '@/services/headers'
import type { ApiSuccessResponse } from '@/types'

interface ValidateCodePayload {
  emailAddress: string
  code: string
  type: 'SMS' | 'EMAIL'
}

interface PasswordReset2FactorPayload {
  emailAddress: string
  emailCode: string
  password: string
}

const AuthorizationService = {
  async login(email: string, password: string): Promise<ApiSuccessResponse> {
    return handleApiCall('/auth/login', {
      method: 'GET',
      headers: { Authorization: basicAuthHeader(email, password) },
    })
  },
  async verifysms(smsCode: string, email: string, password: string): Promise<ApiSuccessResponse> {
    return handleApiCall('/auth/login2Factor', {
      method: 'POST',
      headers: { ...JSON_HEADERS, Authorization: basicAuthHeader(email, password) },
      body: JSON.stringify({ smsCode }),
    })
  },
  async verifyotp(otp: string, email: string, password: string): Promise<ApiSuccessResponse> {
    return handleApiCall('/auth/login2FactorOTP', {
      method: 'POST',
      headers: { ...JSON_HEADERS, Authorization: basicAuthHeader(email, password) },
      body: JSON.stringify({ otp }),
    })
  },
  async passwordResetRequest(email: string): Promise<ApiSuccessResponse> {
    return handleApiCall('/auth/passwordResetRequest', {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify({ emailAddress: email }),
    })
  },
  async validateCode(payload: ValidateCodePayload): Promise<ApiSuccessResponse> {
    return handleApiCall('/auth/validateCode', {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify(payload),
    })
  },
  async passwordReset2Factor(payload: PasswordReset2FactorPayload): Promise<ApiSuccessResponse> {
    return handleApiCall('/auth/passwordReset2Factor', {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify(payload),
    })
  },
  async configureOTP(): Promise<ApiSuccessResponse> {
    return handleApiCall('/auth/configureOTP', {
      method: 'GET',
      headers: JSON_HEADERS,
    })
  },
  async validateOTP(otp: string): Promise<ApiSuccessResponse> {
    return handleApiCall('/auth/validateOTP', {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify({ otp }),
    })
  },
  /** Laat de backend de HttpOnly auth-cookie wissen zonder geldige sessie.
   *  Voor het "inloggen lukt niet"-herstel: /auth/logout kan dit niet, die zit
   *  achter IsAuthenticated en weigert juist als de cookie stuk is. */
  async clearSession(): Promise<ApiSuccessResponse> {
    return handleApiCall('/auth/clearSession', { method: 'POST' })
  },
  async logout(): Promise<ApiSuccessResponse> {
    return handleApiCall('/auth/logout', { method: 'POST' })
  },
  async logoutAllDevices(): Promise<ApiSuccessResponse> {
    return handleApiCall('/auth/logoutAllDevices', { method: 'POST' })
  },
}

export default AuthorizationService
